// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SitePointOfContactModel {
    static getAttributeTypeMap() {
        return SitePointOfContactModel.attributeTypeMap;
    }
}
SitePointOfContactModel.discriminator = undefined;
SitePointOfContactModel.additionalProperties = false;
SitePointOfContactModel.attributeTypeMap = [
    {
        "name": "procurementMethodTypeCode",
        "baseName": "procurementMethodTypeCode",
        "type": "string"
    },
    {
        "name": "procurementMethodTypeDesc",
        "baseName": "procurementMethodTypeDesc",
        "type": "string"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "jobTitle",
        "baseName": "jobTitle",
        "type": "string"
    },
    {
        "name": "phoneNumber",
        "baseName": "phoneNumber",
        "type": "string"
    },
    {
        "name": "phoneNumberExtension",
        "baseName": "phoneNumberExtension",
        "type": "string"
    },
    {
        "name": "faxNumber",
        "baseName": "faxNumber",
        "type": "string"
    },
    {
        "name": "emailAddress",
        "baseName": "emailAddress",
        "type": "string"
    },
    {
        "name": "preferredContactMethod",
        "baseName": "preferredContactMethod",
        "type": "ContactInfoType"
    },
    {
        "name": "procurementMethodTypeId",
        "baseName": "procurementMethodTypeId",
        "type": "number"
    },
    {
        "name": "officeContactNote",
        "baseName": "officeContactNote",
        "type": "string"
    },
];
//# sourceMappingURL=sitePointOfContactModel.js.map